var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon arrow-down-icon",
    viewBox: "0 0 14 7",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.71.164A.815.815 0 0113.831.3a.763.763 0 01-.14 1.092l-6.2 5.444a.818.818 0 01-.982 0l-6.2-5.444A.763.763 0 01.168.3.815.815 0 011.29.164L7 5.237z"
  })));
}

export default SvgArrowDownIconSv;